import React, { useEffect, useState } from "react";

import { fetch } from "../utils/api";
import { Button } from "../components/Button";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { Following } from "../components/Following";
import { ScrollTrigger } from "../components/ScrollTrigger";
import { CtaList } from "../components/CtaList";
import { Link } from "react-router-dom";

import dayjs from "dayjs";
import "../assets/styles/top.scss";

export const Top = () => {
  const [news, setNews] = useState<[]>();
  const [column, setColumn] = useState<[]>();

  useEffect(() => {
    (async () => {
      try {
        const news = await fetch({ category: "news", filter: "per_page=5" });
        if (news.data) setNews(news.data);
        const column = await fetch({
          category: "column",
          filter: "per_page=5",
        });
        if (column.data) setColumn(column.data);
      } catch (error) {
        console.error(error);
      }
    })();
  }, []);

  return (
    <div className="top">
      <Header>
        <>
          <div className="kv">
            <h2>
              <p>
                <img
                  src="../images/kv-text_1.png"
                  alt="大切な資産を共に活かす"
                />
              </p>
              <strong>
                <img src="../images/kv-text_2.png" alt="不動産コンサル" />
              </strong>
              <p>
                <img src="../images/kv-text_3.png" alt="という隣人" />
              </p>
            </h2>
            <img
              src="../images/top-kv.jpg"
              alt="不動産コンサル"
              className="pc-img"
            />
            <img
              src="../images/top-kv_sp.jpg"
              alt="不動産コンサル"
              className="sp-img"
            />
          </div>
          <div className="scroll">
            <div className="scroll-item">
              <p>SCROLL</p>
            </div>
          </div>
        </>
      </Header>
      <section className="about">
        <h3>
          <span>ドリミットはその高い法務・税務知識をもとに</span>
          <br />
          <span>
            <ScrollTrigger
              className="blurIn"
              animationClassName="blurIn-active"
            >
              <strong id="bigTitle">｢資産の最大化｣</strong>
            </ScrollTrigger>
            を目指し提案する
          </span>
          <br />
          <span>不動産コンサルティング会社です</span>
        </h3>
        <h2>
          <p>
            <strong>資産の最大化</strong>
            <span>MAXIMIZE ASSETS</span>
          </p>
          <ScrollTrigger animationClassName="fadeIn-active" className="fadeIn">
            <img src="../images/top-about.png" alt="資産の最大化" />
          </ScrollTrigger>
        </h2>
        <div className="about-contents">
          <div className="inner">
            <ul>
              <li>相続対策</li>
              <li>賃貸経営</li>
              <li>競売/任意売却サポート</li>
              <li>節税対策</li>
              <li>老後資金対策</li>
              <li>負債整理</li>
              <li>最適な管理方法</li>
              <li>資産の買い替え/入れ替え</li>
            </ul>
            <ScrollTrigger
              animationClassName="fadeIn-active"
              className="fadeIn"
            >
              <img src="../images/top-about_sp.png" alt="資産の最大化" />
            </ScrollTrigger>
          </div>
        </div>
      </section>
      <section className="reason">
        <div className="inner">
          <ScrollTrigger
            className="slideIn"
            animationClassName="slideIn-active"
          >
            <h3>ドリミットが選ばれる理由</h3>
          </ScrollTrigger>

          <ol>
            <li>
              <ScrollTrigger
                className="fadeInUp"
                animationClassName="fadeInUp-active"
              >
                <>
                  <h4>
                    <span className="number">01</span>
                    圧倒的な専門知識の深さ！
                  </h4>

                  <p>
                    ドリミットでは提携の大手弁護士法人や税理士と細かい連携を頻繁に行うことで、コンサルタントひとりひとりが最新の情報に触れ、知識を蓄積することができています。
                    <br />
                    <br />
                    そのため、弊社のコンサルタントは
                    <strong>
                      <ScrollTrigger
                        className="borderIn"
                        animationClassName="borderIn-active"
                      >
                        全員が資格保持者
                      </ScrollTrigger>
                    </strong>
                    です。
                    <br />
                    <br />
                    優秀なコンサルタントがお客様目線で、最適なご提案をいたします。
                  </p>
                  <Button
                    text="コンサルタント紹介"
                    href="/consultant"
                    marginTop="3.125vw"
                  />
                </>
              </ScrollTrigger>
            </li>
            <li>
              <ScrollTrigger
                className="fadeInUp"
                animationClassName="fadeInUp-active"
              >
                <>
                  <h4>
                    <span className="number">02</span>
                    <span>
                      相談実績は、創業初年度で
                      <br className="sp-only" />
                      <strong>
                        <ScrollTrigger
                          className="borderIn"
                          animationClassName="borderIn-active"
                        >
                          500件以上！
                        </ScrollTrigger>
                      </strong>
                    </span>
                  </h4>
                </>
              </ScrollTrigger>
            </li>
            <li>
              <ScrollTrigger
                className="fadeInUp"
                animationClassName="fadeInUp-active"
              >
                <>
                  <h4>
                    <span className="number">03</span>
                    無料の不動産コンサルティング
                  </h4>
                  <p>
                    全国に提携の会議室を完備しておりますので、津々浦々どこへでもお伺いし、プライベートコンサルティングを無料で行っております。
                  </p>
                </>
              </ScrollTrigger>
            </li>
            <li>
              <ScrollTrigger
                className="fadeInUp"
                animationClassName="fadeInUp-active"
              >
                <>
                  <h4>
                    <span className="number">04</span>
                    売却後までのきめ細かなサポート
                  </h4>
                  <p>
                    売却活動開始から売却後まで、担当コンサルタントが丁寧にサポートいたします。
                  </p>
                </>
              </ScrollTrigger>
            </li>
            <li>
              <ScrollTrigger
                className="fadeInUp"
                animationClassName="fadeInUp-active"
              >
                <>
                  <h4>
                    <span className="number">05</span>
                    プロ目線で資産運用の管理
                  </h4>
                  <p>
                    購入/取得⇒運用⇒売却まで弊社独自の収支シミュレーションを活用しきめ細やかな管理方法をご提案いたします！
                  </p>
                </>
              </ScrollTrigger>
            </li>
          </ol>

          <div className="button-decoration">
            <div>
              <h4>
                <p>まずは無料でご相談！</p>
                <span>対面・オンラインどちらも承ります</span>
              </h4>
            </div>
          </div>

          <Button text="お申し込みはこちら" href="/contact" />
        </div>
      </section>
      <section
        className="column"
        style={{ backgroundImage: `url(../images/top-column_bg.png)` }}
      >
        <h4>Column</h4>
        <div className="inner">
          <h3>コラム</h3>
          {column && column.length ? (
            <>
              <ul>
                <p className="new">新着</p>
                {column
                  ? (column as []).map((item: any, index) => {
                      return (
                        <li key={index}>
                          <Link to={`column/${item.id}`}>
                            <span className="date">
                              {dayjs(item.date).format("YYYY.MM.DD")}
                            </span>
                            <span>{item.title.rendered}</span>
                          </Link>
                        </li>
                      );
                    })
                  : ""}
              </ul>
              <p className="more">
                <Link to="/column">もっと見る＞</Link>
              </p>
            </>
          ) : (
            <div
              style={{
                textAlign: "center",
                marginTop: "50px",
                fontSize: "16px",
              }}
            >
              コラムの投稿がありません
            </div>
          )}
        </div>
      </section>
      <section className="news">
        <h4>News</h4>
        <div className="inner">
          <h3>お知らせ</h3>
          {news && news.length ? (
            <>
              <p className="new">新着</p>
              <ul>
                {news
                  ? (news as []).map((item: any, index) => {
                      return (
                        <li key={index}>
                          <Link to={`/news/${item.id}`}>
                            <span className="date">
                              {dayjs(item.date).format("YYYY.MM.DD")}
                            </span>
                            <span>{item.title.rendered}</span>
                          </Link>
                        </li>
                      );
                    })
                  : ""}
              </ul>
              <p className="more">
                <Link to="/news">もっと見る＞</Link>
              </p>
            </>
          ) : (
            <div
              style={{
                textAlign: "center",
                marginTop: "50px",
                fontSize: "16px",
              }}
            >
              お知らせの投稿がありません
            </div>
          )}

          {/* <a href="" className="adoption-bnr">
            <img src="../images/adoption-bnr.png" alt="" className="pc-bnr" />
            <img
              src="../images/adoption-bnr_sp.png"
              alt=""
              className="sp-bnr"
            />
          </a> */}
          <CtaList />
        </div>
      </section>
      <Following />
      <footer>
        <Footer />
      </footer>
    </div>
  );
};
